<template>
  <v-slide-y-transition mode="out-in">
    <div id="coa-forms" style="margin-top: -20px">
      <v-container grid-list-xl fluid>
        <v-layout row wrap>
          <v-flex lg12>
          <v-card pa-0>
            <v-toolbar card color="white">
              <v-toolbar-title>{{fm.nama}} ({{fm.calonGedung.number}})</v-toolbar-title>         
              <v-spacer />                              
              <v-btn color="blue" round @click="refresh()" dark>
               Refresh
              </v-btn> 
              <v-menu bottom left>
                <v-btn slot="activator" icon><v-icon>more_vert</v-icon></v-btn>
                <v-list>
                  <v-list-tile v-bind:to="{path:'/tes/ujian_excel'}">
                    <v-list-tile-title>Rekap</v-list-tile-title>
                  </v-list-tile>                       
                </v-list>
              </v-menu>                             
            </v-toolbar>
            <v-divider></v-divider>                  
            <v-card-text class="pa-0 tabular">
              <v-progress-linear slot="progress" color="blue" class="pa-0 ma-0" indeterminate v-if="loading"></v-progress-linear>  
              <div class="v-table__overflow">              
                <v-layout row wrap class="pa-4">
                  <v-flex xs12 md4 v-for="(ujian, i) in fm.mataujians" :key="i">
                    
                    <p>{{ujian.jilidName}}</p>
                    <table class="tb-normal">
                      <thead>
                        <th>No</th>
                        <th>Kunci</th>
                        <th>Jawaban</th>
                      </thead>
                      <tbody>
                        <tr v-for="(jiliddtl, k) in ujian.jilidDtls" :key="k">
                          <template v-if="jiliddtl.option.find(x => x.id == jiliddtl.kunci)">
                            <td>{{jiliddtl.no}}</td>
                            <td>{{(kunci = jiliddtl.option.find(x => x.id == jiliddtl.kunci)) && kunci.key ? kunci.key : kunci.id }}</td>
                            <td :set="resp = ujian.responDtls.find(x => x.no == jiliddtl.no && x.jilid_id==jiliddtl.jilid_id)" >
                              <template v-if="resp && jiliddtl.option.find(x => x.id == resp.answer_id)">
                                {{(answer = jiliddtl.option.find(x => x.id == resp.answer_id)) && answer.key? answer.key : answer.id}} &nbsp; &nbsp; 
                                <v-icon v-if="jiliddtl.kunci == resp.answer_id" color="green">check</v-icon>
                                <v-icon v-else color="red">close</v-icon>
                              </template>
                            </td>     
                          </template>                     
                          <template v-else>
                            <td>{{jiliddtl.no}}</td>
                            <td>{{jiliddtl.option.find(x => x.id == jiliddtl.kunci)}}</td>
                            <td></td>     
                          </template>                     
                        </tr>
                      </tbody>
                    </table>    
                  </v-flex>
                </v-layout>
              </div>              
                
              
            </v-card-text>            
          </v-card>
        </v-flex>                           
        </v-layout>       
      </v-container>
    </div>
  </v-slide-y-transition>
</template>

<script>  
import { debounce } from 'lodash'
import Model from '@/apps/admin/models/Calon';   
const  model = new Model();

export default {
    $_veeValidate: {
      validator: 'new'
    },    
    data: () => ({
      loading: false,
      fm:{
        nama:null,
        calonGedung:{
          number:null,
        },
        mataujians:[],
      }  
    }),  
    watch:{
      
    },    
    mounted(){ 
       this.init();
    },            
    methods: {              
        refresh(){          
          this.init();
        },
      
        format(tgl) { return this.$moment(tgl).format('DD-MM-YYYY')},
        
        getColor(tingkat){
          switch(tingkat){case 1:return 'red darken-2'; case 2: return 'indigo'; case 3:return 'blue-grey'; case 7:return 'light-green'; default:return 'blue-grey';}
        },                

        init(){
          if(this.$route.query.calon_id){
            this.loading = true;
            model.viewUjian({calon_id:this.$route.query.calon_id}).then(data=>{
              if(data.id){                
                Object.assign(this.fm, data);
              }
              this.loading = false;
            })
          }

        }                                           

        
    }
}
</script>
<style>

.tb-normal{    
  border-collapse: collapse;
}
.tb-normal td, .tb-normal th {
  border: 1px solid #ddd;
  padding: 4px 6px;
}

</style>